<ng-template [ngIf]="disabled">
    <input type="text" class="form-control" [value]="tabelaPreco?.nome | uppercase" disabled="disabled" readonly="readonly">
</ng-template>

<ng-template [ngIf]="!disabled">
    <div class="input-group">
        <select 
            #select
            class="form-control" 
            [name]="name"
            [id]="id"
            [required]="required"
            [autofocus]="autofocus"
            [ngModel]="ngModel || ''" 
            (ngModelChange)="onChange($event ? $event : null)">
            <option value="" *ngIf="canSelectNull || (required && !ngModel)">
                {{nullLabel}}
            </option>
            <option *ngFor="let tabelaPreco of tabelasPrecos" [ngValue]="tabelaPreco.id" [disabled]="isSituacaoInativa(tabelaPreco.situacao)">{{tabelaPreco.nome | uppercase}}</option>
        </select>
        <div class="input-group-append" *ngIf="isSituacaoInativa(tabelaPreco?.situacao)">
            <span class="input-group-text">
                <span class="badge badge-danger">Inativa</span>
            </span>
        </div>           
    </div>
</ng-template>